import { atom } from "recoil";
export const CCAsAtom = atom({
  key: "CCAsAtom", // unique ID (with respect to other atoms/selectors)
  default: [], // default value (aka initial value)
});
